import { Icon } from 'office-ui-fabric-react/lib/Icon';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

export class Tuile extends Component {

    static defaultProps = {
        href: undefined,
        iconName: undefined,
        onClick: event => null,
        text: "",
        tileSize: "tile-medium", // tile-wide ; tile-medium ; tile-small
        to: undefined,
    };

    render = () => {
        const { href, iconName, onClick, text, tileSize, to } = this.props;

        if (!!to)
            return <div className={tileSize}>
                <Link to={to} onClick={onClick}>
                    <div className="inner-tile">
                        <Icon iconName={iconName} className="tile-icon" />
                        <span className="tile-text">{text}</span>
                    </div>
                </Link>
            </div>;

        else if (!!href)
            return <div className={tileSize}>
                <a href={href} onClick={onClick}>
                    <div className="inner-tile">
                        <Icon iconName={iconName} className="tile-icon" />
                        <span className="tile-text">{text}</span>
                    </div>
                </a>
            </div>;
    };

};